// extracted by mini-css-extract-plugin
module.exports = {"orderHeader":"orderHeader_orderHeader__4n7TT","purchaseDetail":"orderHeader_purchaseDetail__32gTr"};